import React from "react"
import Tips from '../components/tips'
import ServicesDumpsters from "../components/services-dumpsters"
import LayoutDumpster from "../components/layout-dumpster"
import HowToGuidesSidebar from "../components/how-to-guides-sidebar"
import SidebarForm from "../components/sidebarForm"

const COMMONDUMPSTERS = ({ pageContext }) => 
{ 
    const code = pageContext.code;
    const env = pageContext.env;       
    const populars = pageContext.populars.length > 0 ? pageContext.populars : [];   
    const body = pageContext.content.content !== undefined ? pageContext.content.content: '';


    const seo = 
    {
        url: pageContext.url,
        title: pageContext.content.seo_title,
        description: pageContext.content.seo_desc,
        env: env,
        code: code,
        page: 'basic'
    }

    return (
        <LayoutDumpster seo={seo} env={env} code={code} hidden={true} callToAction={true}>
            
            <div className="blog">

                <div className="container mb-5">
                    <div className="row">
                        <div className="col-lg-8 common">
                             <div class="post single-item">                
                                <div className="resume">                                    
                                    <div class="body" 
                                        dangerouslySetInnerHTML={{__html: body}}></div>
                                </div>
                            </div>                        
                        </div>
                        <div className="col-lg-4">
                            <div className="sidebar no-margin">
                                <div className="block">
                                    <div className="card mb-5">                                   
                                        <SidebarForm site={env.site} code="dumpster" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <div className="card mb-5">                                 
                                        <SidebarForm site={env.site} code="junk-removal" section="blogs"/>
                                    </div>
                                </div>

                                <div className="block">
                                    <ServicesDumpsters  env={env}  />
                                </div>

                                <div className="block">
                                    <HowToGuidesSidebar />
                                </div>

                                <div className="block">
                                    <Tips populars={populars}/>
                                </div>                              

                            </div>                            
                        </div>
                    </div>
                </div> 
            
            
            </div> 

        </LayoutDumpster>
    )
};

export default COMMONDUMPSTERS;